
import * as THREE from "../../libs/three.js/build/three.module.js";
import { ShowMode } from "../defines.js";


export class PotreeRenderer {

	constructor(viewer) {
		this.viewer = viewer;
		this.renderer = viewer.renderer;

		{
			let dummyScene = new THREE.Scene();
			let geometry = new THREE.SphereGeometry(0.001, 2, 2);
			let mesh = new THREE.Mesh(geometry, new THREE.MeshBasicMaterial());
			mesh.position.set(36453, 35163, 764712);
			dummyScene.add(mesh);

			this.dummyMesh = mesh;
			this.dummyScene = dummyScene;
		}
	}

	clearTargets() {

	}

	clear() {
		let { viewer, renderer } = this;


		// render skybox
		if (viewer.background && viewer.background.indexOf("skybox") !== -1) {
			renderer.setClearColor(0xff0000, 1);
		} else if (viewer.background === "gradient") {
			renderer.setClearColor(0x00ff00, 1);
		} else if (viewer.background === "black") {
			renderer.setClearColor(0x000000, 1);
		} else if (viewer.background === "white") {
			renderer.setClearColor(0xFFFFFF, 1);
		} else {
			renderer.setClearColor(0x000000, 0);
		}

		renderer.clear();
	}

	render(params) {
		let { viewer, renderer } = this;

		const camera = params.camera ? params.camera : viewer.scene.getActiveCamera();

		viewer.dispatchEvent({ type: "render.pass.begin", viewer: viewer });

		const renderAreaSize = renderer.getSize(new THREE.Vector2());
		const width = params.viewport ? params.viewport[2] : renderAreaSize.x;
		const height = params.viewport ? params.viewport[3] : renderAreaSize.y;

		// render skybox
		if (viewer.background && viewer.background.indexOf("skybox") !== -1) {
			viewer.skybox.camera.rotation.copy(viewer.scene.cameraP.rotation);
			viewer.skybox.camera.fov = viewer.scene.cameraP.fov;
			viewer.skybox.camera.aspect = viewer.scene.cameraP.aspect;

			viewer.skybox.parent.rotation.x = 0;
			viewer.skybox.parent.updateMatrixWorld();

			viewer.skybox.camera.updateProjectionMatrix();
			renderer.render(viewer.skybox.scene, viewer.skybox.camera);
		} else if (viewer.background === "gradient") {
			renderer.render(viewer.scene.sceneBG, viewer.scene.cameraBG);
		}

		if (viewer.sceneShowModel != ShowMode.GaussianSplats) {
			for (let pointcloud of this.viewer.scene.pointclouds) {
				const { material } = pointcloud;
				material.useEDL = false;
			}

			viewer.pRenderer.render(viewer.scene.scenePointCloud, camera, null, {
				clipSpheres: viewer.scene.volumes.filter(v => (v instanceof Potree.SphereVolume)),
			});
		}

		// render scene
		renderer.render(viewer.scene.scene, camera);

		if (viewer.sceneShowModel != ShowMode.PointClouds) {	// 3DGS
			viewer.renderer.render(viewer.scene.sceneGaussianSplat, camera);
		}

		viewer.clippingTool.update();
		renderer.render(viewer.clippingTool.sceneMarker, viewer.scene.cameraScreenSpace); //viewer.scene.cameraScreenSpace);
		renderer.render(viewer.clippingTool.sceneVolume, camera);

		renderer.render(viewer.controls.sceneControls, camera);

		// splat 深度预 pass：splat 默认 depthWrite=false(不写主屏深度，保半透明混合)，
		// 导致资源盒测不到 splat 深度而不被遮挡。再渲染一遍 splat 只写深度
		// (colorWrite=false)，让资源盒 depthTest 能被 splat 中心点深度遮挡。
		// 第二遍不重跑排序(spark driveSort 有 sorting/sortDirty guard)。
		if (viewer.sceneShowModel != ShowMode.PointClouds && viewer.__sparkRenderer) {
			const sr = viewer.__sparkRenderer;
			const mat = sr.material;
			if (mat) {
				const origDW = mat.depthWrite, origCW = mat.colorWrite;
				mat.depthWrite = true; mat.colorWrite = false; mat.needsUpdate = true;
				// 骗过 onBeforeRender 的 isNewFrame 判断：预 pass 的 renderer.render 会
				// 自增 info.render.frame，导致 spark 误判新帧重跑 generate/sort(闪烁)。
				// 预置 lastFrame=本次 render 将自增到的 frame，使 isNewFrame=false，
				// 跳过 updateInternal，onBeforeRender 仍无条件设 uniform(纹理/instanceCount)。
				sr.lastFrame = viewer.renderer.info.render.frame + 1;
				viewer.renderer.render(sr, camera);
				mat.depthWrite = origDW; mat.colorWrite = origCW;
			}
		}

		// 资源盒(挂载了图片/视频/文本等的 YDBoxVolume)的 box 需被点云/高斯遮挡，
		// 故在 clearDepth 前先渲染它们(写深度+测深度)。VolumeTool 监听此事件只渲染
		// 资源盒 box；overlay pass(render.pass.scene) 会跳过资源盒 box 避免重画覆盖。
		viewer.dispatchEvent({ type: "render.pass.depth", viewer: viewer });

		renderer.clearDepth();

		// Volumes render AFTER GS+scene helpers as an overlay so the box/frame
		// isn't occluded by splats (which use depthTest:true, depthWrite:true).
		// See mirror change in EDLRenderer.render() for the same reasoning.
		viewer.dispatchEvent({ type: "render.pass.scene", viewer: viewer });

		viewer.transformationTool.update();

		viewer.dispatchEvent({ type: "render.pass.perspective_overlay", viewer: viewer });

		// 下面这三行是作者源码注释的。不知道原因。但是因为需要第三行先打开使用
		// renderer.render(viewer.controls.sceneControls, camera);
		// renderer.render(viewer.clippingTool.sceneVolume, camera);
		renderer.render(viewer.transformationTool.scene, camera);

		// renderer.setViewport(width - viewer.navigationCube.width, 
		// 							height - viewer.navigationCube.width, 
		// 							viewer.navigationCube.width, viewer.navigationCube.width);
		// renderer.render(viewer.navigationCube, viewer.navigationCube.camera);		
		// renderer.setViewport(0, 0, width, height);

		viewer.dispatchEvent({ type: "render.pass.end", viewer: viewer });
	}

}
